// extracted by mini-css-extract-plugin
export var container = "Invoices-module--container--8BF2a";
export var content = "Invoices-module--content--po5Um";
export var dateField = "Invoices-module--dateField--HJCr6";
export var datePicker = "Invoices-module--datePicker--6ue4C";
export var noInvoices = "Invoices-module--noInvoices--nmAp1";
export var searchInput = "Invoices-module--searchInput--iFSHI";
export var subHeader = "Invoices-module--subHeader--8zNAU";